import { Component, OnInit, ViewChild } from '@angular/core';
import { CalendarComponent } from 'ng-fullcalendar';
import { Options } from 'fullcalendar';
import { Router, ActivatedRoute } from "@angular/router";

import { ReporteTarea } from '../Models/ReporteTarea';
import { ViajeDetalle } from '../Models/ViajeDetalle';
import { Calendario } from '../Models/Calendario';
import { CalendarioData } from '../Models/CalendarioData';
import { Visita } from '../Models/Visita';

import { CalendarioService } from '../services/calendario.service';
import { VisitaService } from '../services/visita.service';
import { GlobalsService } from '../services/globals.service';
import { ReporteViajeService } from '../services/reporte-viaje.service';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css']
})
export class CalendarioComponent implements OnInit {
  calendarOptions: Options;
  displayEvent: any;

  public mostrarDetalle: boolean = false;
  public mostrarTareas: boolean = false;

  public visita: Visita = new Visita();
  public visitas: Visita[];

  public viajeDetalles: ViajeDetalle = new ViajeDetalle();
  public viajesDetalles: ViajeDetalle[];

  public reporteTarea: ReporteTarea = new ReporteTarea();
  public reporteTareas: ReporteTarea[];

  @ViewChild(CalendarComponent) ucCalendar: CalendarComponent;
  constructor(private calendarioService: CalendarioService, private globalServices: GlobalsService,
    private route: ActivatedRoute, private router: Router, private visitaService: VisitaService,
    private reporteService: ReporteViajeService) { }

  ngOnInit() {

    //carga la información del calendario
    this.calendarioService.ObtenerContadorCalendario(this.globalServices.ObtenerCompania()).subscribe(data => {


      this.calendarOptions = {
        editable: false,
        eventLimit: false,
        navLinks: true,
        displayEventTime: false,
        locale: 'es',
        buttonText: {
          today: 'Hoy',
          month: 'Mes',
          week: 'Semana',
          day: 'Día',
          list: 'Lista'
        },
        header: {
          left: 'prev,next today',
          center: 'title',
          right: 'month,agendaWeek,agendaDay,listMonth'

        },

        events: data



      };
    });
  }

  clickButton(model: any) {
    this.displayEvent = model;
  }
  /**
   * Cuando se da click a alguna pestaña del calendario
   * @param model 
   */
  eventClick(model: any) {
    model = {
      event: {
        id: model.event.id,
        start: model.event.start,
        end: model.event.end,
        title: model.event.title,
        allDay: model.event.allDay
        // other params
      },
      duration: {}
    }
    this.displayEvent = model;

    this.ObtenerVisitasCalendario(this.displayEvent.event.start._i);

    this.mostrarDetalle = true;

  }

  RegresarCalendario() {
    this.mostrarDetalle = false;
    this.mostrarTareas = false;
  }


  ObtenerVisitasCalendario(fecha: Date) {
    try {

      let fecha1 = fecha.toString();

      this.visitaService.ObtenerVisitasCalendario(this.globalServices.ObtenerCompania(), fecha1).subscribe(
        data => {
          this.viajesDetalles = data;

        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("ObtenerVisitasCalendario: " + error);
    }

  }

  ObtenerTareas(item) {
    try {

      this.viajeDetalles = JSON.parse(JSON.stringify(item));
      this.CargarReporteTareas("compania", this.viajeDetalles.idVisita);

      this.mostrarTareas = true;

    } catch (error) {
      console.log(error);
    }
  }


  CargarReporteTareas(idCompania: string, idVisita: string) {
    try {


      this.reporteService.ObtenerReporteTarea(this.globalServices.ObtenerCompania(), idVisita).subscribe(
        data => {
          this.reporteTareas = data;
        },
        err => {
          console.clear();
          console.log(err._body);

        });


    } catch (error) {
      console.log("CargarReporteTareas: " + error);
    }

  }


  /**
   * Convierte la tabla asignada en un exel
   * @param tableID 
   * @param filename 
   */
  exportTableToExcel(tableID, filename = '') {
    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename ? filename + '.xls' : 'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['\ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
  }
}
